import {useEffect, useMemo, useRef, useState} from "react";
import {destructPage, destructSort} from "../../utils/APIUtils";
import {constructFilter, destructFilter} from "../../utils/AdvancedFilterApiUtils.js";

export const PAGE_SIZE = 10;


export const SORT = {
  asc: "asc",
  desc: "desc",
  none: "none"
};

export const SORT_DIRECTIONS = {
  asc: SORT.desc,
  desc: SORT.none,
  none: SORT.asc
};

const NO_SELECTION = -1;

export const useTable = (state, selectionHandler, searchHandler, pageSize = PAGE_SIZE) => {
  const [selection, setSelection] = useState(undefined);

  const [params, setParams] = useState({
        page: (destructPage(state?.page) ?? {page: 0, size: pageSize}),
        filter: (destructFilter(state?.filter) ?? []),
        sort: (destructSort(state?.sort) ?? {}),
        customParams: undefined}); // todo drop custom params.

  const [checked, setChecked] = useState({});
  const [blacklistFlag, setBlacklistFlag] = useState(false);
  const [[forceIncrement, forceFlag], setForceIncrement] = useState([0, false]);

  const total = state.total;

  const autoSelectIndex = useRef(NO_SELECTION); //we use this to select first element when page is loaded, when we go to next page via select next

  const [allChecked, noneChecked, checkedCount] = useMemo(() => {
    const length = Object.keys(checked).length;
    const all = blacklistFlag && length === 0 || !blacklistFlag && length === total;
    const none = blacklistFlag && length === total || !blacklistFlag && length === 0;
    const checkedCount = blacklistFlag ? total - length : length;
    return [all, none, checkedCount];
  }, [checked, blacklistFlag, total]);

  function refreshList() {
    setForceIncrement([forceIncrement + 1, true]);
  }

  function onFilter(filter) {
    setParams(currentParams => {
      const pageParamsNew = constructFilter(filter) === state.filter ? currentParams.page : {...currentParams.page, page: 0};
      return {...currentParams, filter: filter, page: {...pageParamsNew} }
    })
  }

  function onSort(sort) {
    setParams(current => {return {...current, sort: sort}});
  }

  function onPage(page, skipSelection = true) {
    if (selection && !skipSelection) {
      // autoSelectIndex.current = list.indexOf(selection);
    }
    setParams(current => {return {...current, page: {page: page, size: pageSize}}});
  }

  function toLastPage() {
    const lastPage = Math.floor(total / pageSize) - (total % pageSize === 0 ? 1 : 0);
    onPage(lastPage, true);
  }

  function onSelection(selection) {
    setSelection(selection);
    selectionHandler && selectionHandler(selection);
  }

  function onCheck(key) {
    const state = {...checked};
    if (state[key] === !blacklistFlag) {
      delete state[key];
    } else {
      state[key] = !blacklistFlag;
    }
    setChecked(state);
  }

  function isChecked(key) {
    return blacklistFlag && checked[key] !== false || !blacklistFlag && checked[key];
  }

  function onCheckAll() {
    setBlacklistFlag(true);
    setChecked({});
  }

  function onCheckNone() {
    setBlacklistFlag(false);
    setChecked({});
  }

  function selectNextRow() {
    // let index = list.indexOf(selection);
    // if (index > -1) {
    //   if (++index >= list.length) {
    //     if ((params.page.page + 1) * params.page.size < params.page.total) {
    //       onPage(params.page.page + 1);
    //       autoSelectIndex.current = 0;
    //     }
    //   } else {
    //     onSelection(list[index]);
    //   }
    // }
  }

  function isLastRowInPage() {
    // const index = list.indexOf(selection);
    // return index + 1 >= list.length;
  }

  function hasNextRow() {
    // const index = list.indexOf(selection);
    // if (index < 0) {
    //   return total > 0;
    // }
    // return total > params.page.page * params.page.size + index + 1;
  }

  // useUpdateOnlyEffect(() => {
  //   console.log("useTable useUpdateOnlyEffect triggered with list:", list);
  //
  //   if (list.length > 0 && autoSelectIndex.current >= 0) {
  //     console.log("autoSelectIndex.current", autoSelectIndex.current);
  //     onSelection(list[autoSelectIndex.current > list.length - 1 ? list.length - 1 : autoSelectIndex.current]);
  //     autoSelectIndex.current = NO_SELECTION;
  //   }
  // }, [list]);

  useEffect(() => {
    if (searchHandler === undefined) {
      return;
    }
    setForceIncrement([forceIncrement, false]);

    searchHandler(params.page, params.filter, params.sort, params.customParams, forceFlag);
  }, [params.filter, params.sort, params.page.size, params.page.page, forceIncrement, searchHandler]);


  return {
    list: [],
    refreshList,
    selection,
    onSelection,
    selectNextRow,
    hasNextRow,
    isLastRowInPage,
    page: params.page,
    onPage,
    toLastPage,
    filter: params.filter,
    onFilter,
    sort: params.sort,
    onSort,
    customParams: params.customParams,
    isChecked,
    checked,
    checkedCount,
    onCheck,
    allChecked,
    onCheckAll,
    noneChecked,
    onCheckNone,
    blacklistFlag,
    total,
  };
}
